import React from 'react';
import './PublicLayout.css';
import PublicHeader from '../PublicHeader/PublicHeader';

const PublicLayout = ({ children }) => (
  <div className="main-layout overflow-hidden">
    <div>
      <PublicHeader />
      <div id="main">
        <div id="content" className="container-fluid">
          {children}
        </div>
      </div>
      <footer className="page-footer position-absolute text-right">
        <div className="txt-color-white inline-block">
          <span className="txt-color-blueLight hidden-mobile">
            <a href="/terms" target="_blank">Terms of Service</a>
            {' '}
            | © Copyright 2022 AVTECH Software, Inc.
          </span>
        </div>
      </footer>
    </div>
  </div>
);

export default PublicLayout;
